import {
  IconLayoutDashboard, IconUsers, IconSchool, IconBook, IconCalendarTime,
  IconCalendarCheck, IconChecklist, IconBook2, IconCash, IconReportAnalytics,
  IconUserPlus, IconSpeakerphone, IconBriefcase, IconSettings, IconMessageCircle, IconCrown, IconUsersGroup, IconChalkboard, IconBell, IconSticker2, IconReceipt2, IconPhoto,
  IconBuildingCommunity, IconGift, IconHeadset, IconLifebuoy, IconShieldLock,
  IconTrophy, IconMoodSmile, IconFileCertificate, IconFileText, IconNotebook, IconCalendarStats, type Icon, IconDeviceCctv, IconDevicesPc, IconDeviceDesktopAnalytics, IconWallet,} from '@tabler/icons-react';
import { PREMIUM_SECTIONS, Section } from './permissions';
import { PREMIUM_UI_ENABLED } from './features';

export interface NavItem {
  to: string;
  labelKey: string; // i18n kaliti (nav.*)
  icon: Icon;
  section: Section;
}

export interface NavGroup {
  labelKey: string; // navGroups.*
  items: NavItem[];
}

/** Sidebar va Spotlight uchun umumiy navigatsiya (guruhlangan, tarjima kalitlari bilan).
 *  Har item `section` bo'yicha canAccess() bilan filtrlanadi — superadmin faqat SaaS
 *  guruhini, tenant admini esa tenant guruhlarini ko'radi.
 *
 *  XOM ro'yxat: premium muzlatilgan bo'lsa pastda filtrlanadi (`NAV_GROUPS`). */
const RAW_NAV_GROUPS: NavGroup[] = [
  {
    labelKey: 'navGroups.main',
    items: [
      { to: '/', labelKey: 'nav.dashboard', icon: IconLayoutDashboard, section: 'dashboard' },
      // Qabul tepada: yangi murojaat — maktab uchun yangi mijoz; "Ochiq" nishoni aylantirmasdan ko'rinsin
      { to: '/admissions', labelKey: 'nav.admissions', icon: IconUserPlus, section: 'admissions' },
    ],
  },
  {
    labelKey: 'navGroups.academics',
    items: [
      { to: '/students', labelKey: 'nav.students', icon: IconUsers, section: 'students' },
      { to: '/parents', labelKey: 'nav.parents', icon: IconUsersGroup, section: 'parents' },
      { to: '/teachers', labelKey: 'nav.teachers', icon: IconChalkboard, section: 'teachers' },
      { to: '/classes', labelKey: 'nav.classes', icon: IconSchool, section: 'classes' },
      { to: '/subjects', labelKey: 'nav.subjects', icon: IconBook, section: 'subjects' },
      { to: '/schedule', labelKey: 'nav.schedule', icon: IconCalendarTime, section: 'schedule' },
      { to: '/attendance', labelKey: 'nav.attendance', icon: IconCalendarCheck, section: 'attendance' },
      { to: '/grades', labelKey: 'nav.grades', icon: IconChecklist, section: 'grades' },
      { to: '/journal', labelKey: 'nav.journal', icon: IconNotebook, section: 'journal' },
      { to: '/homework', labelKey: 'nav.homework', icon: IconBook2, section: 'homework' },
      { to: '/ranking', labelKey: 'nav.ranking', icon: IconTrophy, section: 'ranking' },
      { to: '/behavior', labelKey: 'nav.behavior', icon: IconMoodSmile, section: 'behavior' },
      { to: '/exams', labelKey: 'nav.exams', icon: IconFileCertificate, section: 'exams' },
    ],
  },
  {
    labelKey: 'navGroups.finance',
    items: [
      { to: '/payments', labelKey: 'nav.payments', icon: IconCash, section: 'payments' },
      { to: '/reports', labelKey: 'nav.reports', icon: IconReportAnalytics, section: 'reports' },
      { to: '/expenses', labelKey: 'nav.expenses', icon: IconReceipt2, section: 'expenses' },
      { to: '/payroll', labelKey: 'nav.payroll', icon: IconWallet, section: 'payroll' },
    ],
  },
  {
    labelKey: 'navGroups.management',
    items: [
      { to: '/contracts', labelKey: 'nav.contracts', icon: IconFileText, section: 'contracts' },
      { to: '/announcements', labelKey: 'nav.announcements', icon: IconSpeakerphone, section: 'announcements' },
      { to: '/banners', labelKey: 'nav.banners', icon: IconPhoto, section: 'banners' },
      { to: '/notifications', labelKey: 'nav.notifications', icon: IconBell, section: 'notifications' },
      { to: '/premium', labelKey: 'nav.premium', icon: IconCrown, section: 'premium' },
      { to: '/support', labelKey: 'nav.support', icon: IconMessageCircle, section: 'support' },
      { to: '/platform-support', labelKey: 'nav.platformSupport', icon: IconLifebuoy, section: 'platform-support' },
      { to: '/academic-years', labelKey: 'nav.academicYears', icon: IconCalendarStats, section: 'academic-years' },
      { to: '/staff', labelKey: 'nav.staff', icon: IconBriefcase, section: 'staff' },
      { to: '/faceid', labelKey: 'nav.faceid', icon: IconDeviceCctv, section: 'faceid' },
      { to: '/settings', labelKey: 'nav.settings', icon: IconSettings, section: 'settings' },
    ],
  },
  {
    labelKey: 'navGroups.platform',
    items: [
      { to: '/tenants', labelKey: 'nav.tenants', icon: IconBuildingCommunity, section: 'tenants' },
      { to: '/qurilmalar', labelKey: 'nav.qurilmalar', icon: IconDevicesPc, section: 'qurilmalar' },
      { to: '/superadmin/agentlar', labelKey: 'nav.agentlar', icon: IconDeviceDesktopAnalytics, section: 'agentlar' },
      { to: '/saas-premium', labelKey: 'nav.saasPremium', icon: IconCrown, section: 'saas-premium' },
      { to: '/saas-gifts', labelKey: 'nav.saasGifts', icon: IconGift, section: 'saas-gifts' },
      { to: '/saas-support', labelKey: 'nav.saasSupport', icon: IconHeadset, section: 'saas-support' },
      { to: '/audit', labelKey: 'nav.audit', icon: IconShieldLock, section: 'audit' },
      { to: '/stickers', labelKey: 'nav.stickers', icon: IconSticker2, section: 'stickers' },
    ],
  },
];

/**
 * Yakuniy navigatsiya. Premium muzlatilganda (`PREMIUM_UI_ENABLED = false`)
 * premium bo'limlari yon menyudan ham, Spotlight'dan ham chiqib ketadi —
 * ular AppLayout/SpotlightSearch da shu ro'yxatdan olinadi. Bandlari qolmagan
 * guruh butunlay tashlab yuboriladi (bo'sh sarlavha osilib qolmasin;
 * AppLayout ham o'z navbatida bo'sh guruhni chizmaydi).
 */
export const NAV_GROUPS: NavGroup[] = PREMIUM_UI_ENABLED
  ? RAW_NAV_GROUPS
  : RAW_NAV_GROUPS
      .map((g) => ({ ...g, items: g.items.filter((i) => !PREMIUM_SECTIONS.includes(i.section)) }))
      .filter((g) => g.items.length > 0);

export const ALL_NAV_ITEMS: NavItem[] = NAV_GROUPS.flatMap((g) => g.items);
